module.exports = __webpack_public_path__ + "img/search.93c00ad9.png";